// format-amount.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAmount'
})
export class FormatAmountPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Remove leading zeros
    value = value.replace(/^0+/, '');

    // Ensure there are at least 3 digits for the fractional part
    while (value.length < 4) {
      value = '0' + value;
    }

    // Split into integer and fractional parts
    let integerPart = value.slice(0, -3) || '0';
    let fractionalPart = value.slice(-3);

    return `${integerPart}.${fractionalPart}`;
  }

}
